import React from "react";
import { Modal, Button, Alert } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
`;

const WarningContent = styled.div`
  padding: 20px 0;
`;

const EventName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #3c2f61;
  margin: 15px 0;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 6px;
  text-align: center;
`;

const WarningText = styled.p`
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 15px 0;
`;

const DeleteConfirmationModal = ({ 
  visible, 
  eventName, 
  onConfirm, 
  onCancel, 
  loading 
}) => {
  return (
    <StyledModal
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: "#ff4d4f", marginRight: "8px" }} />
          Confirm Event Deletion
        </span>
      }
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} size="large">
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={onConfirm}
          loading={loading}
          size="large"
        >
          Yes, Delete Event
        </Button>,
      ]}
      width={500}
      closable={!loading}
      maskClosable={!loading}
    >
      <WarningContent>
        <Alert
          message="Warning: This action cannot be undone!"
          description="Deleting this event will permanently remove it from the system."
          type="error"
          showIcon
          style={{ marginBottom: "20px" }}
        />

        <WarningText>
          Are you sure you want to delete the following event?
        </WarningText>

        <EventName>"{eventName}"</EventName>

        <WarningText>
          This will:
        </WarningText>
        <ul style={{ color: "#666", paddingLeft: "20px" }}>
          <li>Permanently delete the event from the database</li>
          <li>Remove the event image (if not used elsewhere)</li>
          <li>Remove all associated event data</li>
        </ul>

        <Alert
          message="Members will NOT be notified about this deletion"
          type="warning"
          showIcon
          style={{ marginTop: "15px" }}
        />
      </WarningContent>
    </StyledModal>
  );
};

export default DeleteConfirmationModal;